<template>
  <div
    :class="{ _mobile: isMobile }"
    class="unavailable-panel"
  >
    <icon-alert
      width="24px"
      height="24px"
      class="unavailable-panel__icon"
    />
    <div class="unavailable-panel__info">
      <h4 class="unavailable-panel__title">
        Эти товары раскупили
      </h4>
      <p class="unavailable-panel__description">
        Удалите их из корзины, чтобы перейти к оформлению заказа
      </p>
    </div>
    <change-all-items
      v-if="!isMobile"
      :is-deleted-all="false"
      class="unavailable-panel__change-all"
      @changeAllItems="handlerDeleteAll"
    />
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

import ChangeAllItems from '@/components/_desktop/LayoutPage/ChangeAllItems';

// icons
import IconAlert from '@/assets/sprite/svg/24/Alert_24.svg';

export default defineComponent({
  name: 'UnavailablePanel',
  components: {
    IconAlert,
    ChangeAllItems,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const handlerDeleteAll = () => emit('onDeleteAll');
    return { handlerDeleteAll };
  },
});
</script>

<style lang="less">
.unavailable-panel {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: @size-x3 @size-x4;
  background: @yellow-back;

  &._mobile {
    padding: @size-x3 @size-x4;
  }

  &__icon {
    margin-right: @size-x2;
    fill: @orange-warning;
  }

  &__info {
    margin-right: auto;
  }

  &__title {
    .h-reset;
    .p;

    padding: 0;
  }

  &__description {
    .small;

    margin: 0;
  }
}
</style>
